import { Link } from "react-router-dom";
import { Alert } from "reactstrap";
import { clearAllErrors, clearError } from "../../actions/errorActions";
import { RootState, useAppDispatch, useAppSelector } from "../../store";

function ActiveErrors(props: any) {

    const {
        errorLink,
        errorLinkText
    }: {
        errorLink: string,
        errorLinkText: string
    } = props;

    const dispatch = useAppDispatch();
    const activeErrors = useAppSelector((state: RootState) => state.apiErrors.activeErrors);


    const dismiss = (e: any, actionId: string) => {
        e.preventDefault();
        dispatch(clearError(actionId));
    }

    const dismissAll = () => {
        dispatch(clearAllErrors());
    }

    return (
        <div>
            {activeErrors && activeErrors.map((currentError: any, i: number) =>
                <Alert key={i} color="danger" isOpen={true} toggle={(event) => dismiss(event, currentError.actionId)}>
                    {currentError.error.detail}
                    {errorLink &&
                        <div>
                            <Link to={errorLink}>{errorLinkText}</Link>
                        </div>
                    }
                </Alert>
            )}
        </div>
    );
}

export default ActiveErrors;